// extracted by mini-css-extract-plugin
export var carrierNotice = "_jq-5";
export var carrierNoticePlaceholder = "_jq-6";
export var deliveryRow = "_jq-c";
export var fixedHeight = "_jq-4";
export var freightLogo = "_jq-b";
export var fullWidth = "_jq-3";
export var priceColumn = "_jq-7";
export var radioSelected = "_jq-9";
export var radioUnselected = "_jq-8";
export var selectedOption = "_jq-2";
export var selectedOptionContainer = "_jq-1";
export var selection = "_jq-0";
export var tallSkeletonText = "_jq-a";